<div class="gb-ask" [class.gb-ask--listening]="isListening()" [class.gb-ask--busy]="busy()">
  <span
    class="gb-ask__icon"
    [style.-webkit-mask-image]="'url(assets/svg/search-outline.svg)'"
    [style.mask-image]="'url(assets/svg/search-outline.svg)'"></span>
  <input
    class="gb-ask__input"
    type="text"
    autocomplete="off"
    [placeholder]="isListening() ? ('Listening…' | translate) : (placeholder() | translate)"
    [value]="text()"
    (input)="onInput($event)"
    (keydown.enter)="submit()" />
  @if (text()) {
    <button type="button" class="gb-ask__btn" (click)="clear()" title="Clear">
      <span
        class="gb-ask__btn-icon"
        [style.-webkit-mask-image]="'url(assets/svg/close-outline.svg)'"
        [style.mask-image]="'url(assets/svg/close-outline.svg)'"></span>
    </button>
  }
  @if (speechSupported) {
    <button
      type="button"
      class="gb-ask__btn gb-ask__mic"
      [class.gb-ask__mic--active]="isListening()"
      (click)="toggleListening()"
      [title]="isListening() ? ('Stop listening' | translate) : ('Speak your question' | translate)">
      <span
        class="gb-ask__btn-icon"
        [style.-webkit-mask-image]="'url(assets/svg/mic-outline.svg)'"
        [style.mask-image]="'url(assets/svg/mic-outline.svg)'"></span>
    </button>
  }
  <button
    type="button"
    class="gb-ask__btn gb-ask__submit"
    [disabled]="!text().trim() || busy()"
    (click)="submit()"
    title="Ask">
    <span
      class="gb-ask__btn-icon"
      [style.-webkit-mask-image]="'url(assets/svg/arrow-up-outline.svg)'"
      [style.mask-image]="'url(assets/svg/arrow-up-outline.svg)'"></span>
  </button>
</div>
